import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function followReducer(state = initialState.doIFollow, action) {
  switch (action.type) {
    case types.DO_I_FOLLOW_SUCCESS:
      return action.doIFollowArray;

    case types.FOLLOW_TOGGLE_SUCCESS: {
      return state.map((user) => {
        const newObj = { ...user };
        if (newObj.user_id === action.userId.toString()) {
          newObj.doIFollow = action.followBool;
        }
        return newObj;
      });
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./library/app/reducers/followReducer.js